import store from "@/store";
// import { convertCurrency } from "@/constants/formater";

const hasCookie = (type) => {

  if (process.env.VUE_APP_COOKIECONSENT === "true") {
    const COOKIE = Symbol("Cookie");
    let lastCookies = document.cookie;

    const getCookie = (cname) => {
      const name = cname + "=";
      const decodedCookie = decodeURIComponent(lastCookies);
      const ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return JSON.parse(c.substring(name.length, c.length));
        }
      }
      return false;
    };

    const checkCookie = () => {

      if (process.env.VUE_APP_COOKIECONSENTARRAY === "true") {
        const cookie = getCookie(process.env.VUE_APP_COOKIECONSENTCOOKIENAME);

        if (cookie.options) {
          return cookie.options.find(
            (element) =>
              element === type
          );
        } else if (cookie.checkboxes) {
          return cookie.checkboxes.find(
            ({name}) =>
              name === type
          ).checked;
        }
        return false
      } else {
        if (
          getCookie(type) ==
          (true || 1)
        ) {
          return true;
        } else {
          return false;
        }
      }
    };

    Object.defineProperty(
      Document.prototype,
      COOKIE,
      Object.getOwnPropertyDescriptor(Document.prototype, "cookie")
    );

    Object.defineProperty(Document.prototype, "cookie", {
      enumerable: true,
      configurable: true,
      get() {
        return this[COOKIE];
      },
      set(value) {
        this[COOKIE] = value;

        if (value === lastCookies) {
          return false;
        }
        lastCookies = value;
        return checkCookie();
      },
    });

    return checkCookie();
  } else {
    return true;
  }
}


const getParam = (p) => {
  const match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

const getExpiryRecord = (value) => {
  const expiryPeriod = 90 * 24 * 60 * 60 * 1000; // Ablauf nach 90 Tagen in Millisekunden

  const expiryDate = new Date().getTime() + expiryPeriod;
  return {
    value: value,
    expiryDate: expiryDate
  };
}

const addGclid = () => {

  if (!hasCookie("statistics")) {
    localStorage.removeItem('gclid')
    return
  }

  const gclidParam = getParam('gclid');
  let gclidRecord = null;

  const gclsrcParam = getParam('gclsrc');
  const isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;


  if (gclidParam && isGclsrcValid) {
    gclidRecord = getExpiryRecord(gclidParam);
    localStorage.setItem('gclid', JSON.stringify(gclidRecord));
  }

  const gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
  const isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;

  if (isGclidValid) {
    return gclid.value;
  }
}

const get_ga_clientid = () => {
  const cookie = document.cookie.match(/_ga=([^;]+)/);
  if (cookie) {
    const parts = cookie[1].split('.');
    return parts[2] + '.' + parts[3]; // gibt "1234567890.1234567890" zurück
  }
  return null;
}

const get_ga_sessid = () => {
  const match = document.cookie.match(/_ga_[A-Z0-9]+=([^;]+)/);
  if (match) {
    const sessionMatch = match[1].match(/\.s(\d+)\$/);
    if (sessionMatch) {


      return sessionMatch[1];
    }
  }
  return null;
}

const generateDataLayerValue = async (type, options) => {
  const getItemconstiation = async () => {
    const succ = await store.getters["reservation/GET_RESERVATION_SUCCESS"];

    const time =
      "Zeitraum " +
      (await generateDataLayerValue("getReservationDuration", options)) +
      " Tag(e)";

    let extras = "";
    let tarif = "";
    let insurance_rates = "";
    let delivery = "";
    if (succ.invoice_positions) {
      tarif = succ.invoice_positions.mainRates[0]
        ? succ.invoice_positions.mainRates[0].description
        : "";

      insurance_rates = succ.invoice_positions.insuranceRates[0]
        ? succ.invoice_positions.insuranceRates[0].description
        : "";
      delivery =
        succ.invoice_positions.deliveryPickupRates.length > 0
          ? "Zustellung/Abholung, "
          : "";

      succ.invoice_positions.subRates.forEach((element) => {
        extras += element.description + ", ";
      });
    } else {
      tarif = succ.main_rates[0] ? succ.main_rates[0].description : "";

      insurance_rates = succ.insurance_rates[0]
        ? succ.insurance_rates[0].description
        : "";
      delivery =
        succ.delivery_pickup_rates.length > 0 ? "Zustellung/Abholung, " : "";

      succ.sub_rates.forEach((element) => {
        extras += element.description + ", ";
      });
    }

    const result =
      time + ", " + tarif + ", " + insurance_rates + ", " + delivery + extras;
    // console.log(result);
    return result;
  };
  // console.log("generateDataLayerValue_type", type);
  const sess = await store.getters["userSession/GET_SESSION"];
  const branch = await store.getters["userSession/GET_BRANCH"];

  let caseType = type;
  if (branch == "Auto-Abo" && type == "getCarItem") caseType = "getCarItemAbo";

  switch (caseType) {
    case "getStationCarListId": {
      return sess.selectedStation + "_carlist";
    }
    case "getCarList": {
      const filterdCar = [];
      if (branch == "Auto-Abo") {
        const vehicles = await store.dispatch("cargroup/GET_VEHICLES_V2", {
          top: false,
        });
        vehicles.vehicles.forEach((element) => {
          filterdCar.push({
            item_id: element.id,
            item_name: element.vehicle_name,
            affiliation: sess.selectedStation,
            quantity: 1,
          });
        });
        console.log("vehicles", vehicles);

      } else {
        const GET_CARGROUPS = await store.getters[
          "cargroup/GET_GROUPS_FROM_SELECTEDSTATION"
          ];

        GET_CARGROUPS.forEach((element) => {
          filterdCar.push({
            item_id: element.id,
            item_name: element.text_web,
            affiliation: sess.selectedStation,
            quantity: 1,
          });
        });
      }


      return filterdCar;
    }
    case "getCarItem": {
      const GET_CARGROUP = await store.getters["userSession/GET_CARGROUP"];
      const GET_CARGROUPS = await store.getters[
        "cargroup/GET_GROUPS_FROM_SELECTEDSTATION"
        ];
      const index =
        GET_CARGROUPS.findIndex((element) => element.id === GET_CARGROUP) + 1;

      const GET_CARGROUP_BY_ID = await store.getters[
        "cargroup/GET_CARGROUP_BY_ID"
        ](GET_CARGROUP);
      const item_category = GET_CARGROUP_BY_ID.vehicle_category[0].id;

      // GET_CARGROUP_BY_ID.vehicle_category.forEach((element) => {
      //   item_category += element.id + ",";
      // });

      const succ = await store.getters["reservation/GET_RESERVATION_SUCCESS"];

      const coupon = await generateDataLayerValue("getCoupon", options);
      let discount = 0;

      let total_uncouponedprice =
        parseFloat(succ.total_price_delivery_pickup) +
        parseFloat(succ.total_price_insurance) +
        parseFloat(succ.total_price_main_rates) +
        parseFloat(succ.total_price_payment) +
        parseFloat(succ.total_price_subrates);

      if (succ.voucher_rates) {
        discount =
          succ.voucher_rates.length > 0
            ? Math.abs(succ.voucher_rates[0].long_price)
            : 0;
      }
      if (succ.invoice_positions) {
        discount =
          succ.invoice_positions.voucherRates.length > 0
            ? Math.abs(succ.invoice_positions.voucherRates[0].long_price)
            : 0;

        total_uncouponedprice =
          parseFloat(succ.invoice_positions.endPositions[2].total_price) +
          parseFloat(discount);
      }
      const selectedOffer = await store.getters["offers/GET_OFFERSELECTED"];
      let promotion_id_to_string = "";
      let promotion_name;
      if (Object.keys(selectedOffer).length > 0) {
        promotion_id_to_string = selectedOffer.rate_code;
        promotion_name = selectedOffer.headline;
      }
      let promotion_id;
      if (promotion_id_to_string !== "") {
        promotion_id = promotion_id_to_string;
      }
      const returnObject = {
        item_id: GET_CARGROUP_BY_ID.id,
        item_name: GET_CARGROUP_BY_ID.text_web,
        affiliation: sess.selectedStation,
        coupon,
        discount,
        index,
        item_brand: store.getters["userSession/GET_STATIONTYPE"],
        item_category,
        quantity: 1,
        price: total_uncouponedprice,
        promotion_id,
        promotion_name,
        item_variant: await getItemconstiation(),
      };
      if (coupon == "") {
        delete returnObject.coupon;
        delete returnObject.discount;
      }
      return [returnObject];
    }
    case "getCarItemAbo": {
      const GET_CARGROUP = await store.getters["userSession/GET_CARGROUP"];
      const GET_VEHICLE = await store.getters["userSession/GET_VEHICLE"];
      const GET_CARGROUPS = await store.getters[
        "cargroup/GET_GROUPS_FROM_SELECTEDSTATION"
        ];
      const index =
        GET_CARGROUPS.findIndex((element) => element.id === GET_CARGROUP) + 1;

      const GET_CARGROUP_BY_ID = await store.getters[
        "cargroup/GET_CARGROUP_BY_ID"
        ](GET_CARGROUP);


      const item_category = GET_CARGROUP_BY_ID.vehicle_category[0].id;

      // GET_CARGROUP_BY_ID.vehicle_category.forEach((element) => {
      //   item_category += element.id + ",";
      // });

      const succ = await store.getters["reservation/GET_RESERVATION_SUCCESS"];
      // const selectedAbo = await store.getters["reservation/GET_SELECTEDABO"];
      // const MONTHS = parseInt(selectedAbo[0]);

      const coupon = await generateDataLayerValue("getCoupon", options);
      let discount = 0;

      let total_uncouponedprice =
        parseFloat(succ.end_positions[2].total_price);

      if (succ.voucher_rates) {
        discount =
          succ.voucher_rates.length > 0
            ? Math.abs(succ.voucher_rates[0].long_price)
            : 0;
      }
      if (succ.invoice_positions) {
        discount =
          succ.invoice_positions.voucherRates.length > 0
            ? Math.abs(succ.invoice_positions.voucherRates[0].long_price)
            : 0;

        total_uncouponedprice =
          parseFloat(succ.invoice_positions.endPositions[2].total_price) +
          parseFloat(discount);
      }
      const selectedOffer = await store.getters["offers/GET_OFFERSELECTED"];
      let promotion_id_to_string = "";
      let promotion_name;
      if (Object.keys(selectedOffer).length > 0) {
        promotion_id_to_string = selectedOffer.rate_code;
        promotion_name = selectedOffer.headline;
      }
      let promotion_id;
      if (promotion_id_to_string !== "") {
        promotion_id = promotion_id_to_string;
      }
      const returnObject = {
        item_id: GET_VEHICLE['id'],
        item_name: GET_VEHICLE['vehicle_name'],
        affiliation: sess.selectedStation,
        coupon,
        discount,
        index,
        item_brand: store.getters["userSession/GET_STATIONTYPE"],
        item_category,
        quantity: 1,
        price: total_uncouponedprice,
        promotion_id,
        promotion_name,
        item_variant: await getItemconstiation(),
      };
      if (coupon == "") {
        delete returnObject.coupon;
        delete returnObject.discount;
      }
      // console.log("dataLayer", returnObject);

      return [returnObject];
    }
    case "getCoupon": {
      const succ = await store.getters["reservation/GET_RESERVATION_SUCCESS"];
      // console.log(succ);
      let coupon = "";
      if (succ.voucher_rates) {
        coupon =
          succ.voucher_rates.length > 0 ? succ.voucher_rates[0].rate : "";
      }
      if (succ.invoice_positions) {
        coupon =
          succ.invoice_positions.voucherRates.length > 0
            ? succ.invoice_positions.voucherRates[0].rate
            : "";
      }

      return coupon;
    }
    case "getCarCategory": {
      const GET_CARGROUP = await store.getters["userSession/GET_CARGROUP"];
      const GET_CARGROUP_BY_ID = await store.getters[
        "cargroup/GET_CARGROUP_BY_ID"
        ](GET_CARGROUP);
      if (options.car) {
        return options.car.category || "";
      }
      if (GET_CARGROUP_BY_ID) {
        return GET_CARGROUP_BY_ID.vehicle_category[0].id;
      } else {
        return;
      }
    }
    case "getCarGroup": {
      const GET_CARGROUP = await store.getters["userSession/GET_CARGROUP"];
      const GET_CARGROUP_BY_ID = await store.getters[
        "cargroup/GET_CARGROUP_BY_ID"
        ](GET_CARGROUP);
      if (options.car) {
        return options.car.id || "";
      }
      if (GET_CARGROUP_BY_ID) {
        return GET_CARGROUP_BY_ID.text_web;
      } else {
        return;
      }
    }

    case "getVehicleId": {
      return "getVehicleId";
    }
    case "getStationStart": {
      return sess.selectedStation || "";
    }
    case "getStationEnd": {
      return sess.selectedStationEnd || sess.selectedStation;
    }
    case "getReservationDuration": {
      const date_1 = new Date(sess.reservationDate.start);
      const date_2 = new Date(sess.reservationDate.end);

      const days = (date_1, date_2) => {
        const difference = date_1.getTime() - date_2.getTime();
        const TotalDays = -Math.ceil(difference / (1000 * 3600 * 24));
        if (TotalDays == 0) return 1;
        return TotalDays;
      };
      return days(date_1, date_2);
    }
    case "getTimeStamp": {
      return new Date().getTime();
    }
    case "getScreenSize": {
      return window.screen.width + "x" + window.screen.height;
    }
    case "getTotalPrice": {
      // const succ = await store.getters["reservation/GET_RESERVATION_SUCCESS"];
      // console.log(succ);
      if (await store.getters["reservation/GET_RESERVATION"]) {
        const GET_RESERVATION = await store.getters[
          "reservation/GET_RESERVATION"
          ];
        return Math.abs(GET_RESERVATION.end_positions[2].total_price);
      } else if (await store.getters["reservation/GET_RESERVATION_SUCCESS"]) {
        const GET_RESERVATION = await store.getters[
          "reservation/GET_RESERVATION_SUCCESS"
          ];
        return Math.abs(
          GET_RESERVATION.invoice_positions.endPositions[2].total_price
        );
      } else {
        return;
      }
    }
    case "getCurrency": {
      return "EUR";
    }
    case "getSelectValue": {
      return options;
    }
    case "getDealerName": {
      const station = await store.getters["stations/GET_STATIONS_FILTERED"];

      const selected = station["ALL"].find(
        (station) => station.id === sess.selectedStation
      );

      return selected.name;
    }
    case "getDealerAddress": {
      const station = await store.getters["stations/GET_STATIONS_FILTERED"];

      const selected = station["ALL"].find(
        (station) => station.id === sess.selectedStation
      );

      return selected.street + ", " + selected.zipcode + " " + selected.city;
    }
    case "getDealerId": {
      return "getDealerId";
    }
    case "getLeadId": {
      return "getLeadId";
    }
    case "getTicked": {
      if (options) {
        return "ticked";
      } else {
        return "unticked";
      }
    }
    case "getDestination": {
      return options.destination;
    }
    case "getExtraPrice": {
      return options.extra.total_long_price;
    }
    case "getExtraLabel": {
      return options.extra.description;
    }
    case "getAddRemove": {
      return options.amount == 0 ? "remove" : "add";
    }
    case "getPaymentMethod": {
      const form = await store.getters["reservation/GET_CUSTOMER"];
      const cargroup = await store.getters["userSession/GET_CARGROUP"];
      const paymentMethods = await store
        .dispatch("reservation/GET_PAYMENT_METHODS", cargroup)
        .then((result) => {
          return result;
        });
      if (paymentMethods.find((x) => x.id == form.payment_method_id)) {
        return paymentMethods.find((x) => x.id == form.payment_method_id)
          .designation_web;
      } else {
        return "OnlinePayment";
      }
    }
    case "getReservationNumber": {
      const succ = await store.getters["reservation/GET_RESERVATION_SUCCESS"];
      return succ.id;
    }
    case "getTax": {
      const succ = await store.getters["reservation/GET_RESERVATION_SUCCESS"];

      let tax = "";
      if (succ.end_positions) {
        tax =
          succ.end_positions.length > 0
            ? succ.end_positions[1].total_price
            : "";
      }
      if (succ.invoice_positions.endPositions) {
        tax =
          succ.invoice_positions.endPositions.length > 0
            ? succ.invoice_positions.endPositions[1].total_price
            : "";
      }
      return tax;
    }
    case "getPromotionId": {
      const selectedOffer = await store.getters["offers/GET_OFFERSELECTED"];
      let promotion_id_to_string = "";

      if (Object.keys(selectedOffer).length > 0) {
        promotion_id_to_string = selectedOffer.rate_code;
      }
      let promotion_id;
      if (promotion_id_to_string !== "") {
        promotion_id = promotion_id_to_string;
      }
      return promotion_id;
    }
    case "getPromotionName": {
      const selectedOffer = await store.getters["offers/GET_OFFERSELECTED"];

      let promotion_name;
      if (Object.keys(selectedOffer).length > 0) {
        promotion_name = selectedOffer.headline;
      }
      return promotion_name;
    }

    default:
      return type;
  }
};


const generateDataLayer = async (eventtype, options) => {
  const config = JSON.parse(process.env.VUE_APP_ANALYTICS_CONFIG);
  // console.log("config", config);
  const event = config.orm[eventtype] || {};
  const attributes = JSON.parse(JSON.stringify(event));

  for (const type in event) {
    // console.log("event", typeof event[type]);
    // console.log("event", event[type]);
    switch (typeof event[type]) {
      case "object":
        // console.log("object");
        for (const key in event[type]) {
          attributes[type][key] = await generateDataLayerValue(
            event[type][key],
            options
          );
        }
        break;
      case "array":
        for (const key in event[type]) {
          attributes[type][key] = await generateDataLayerValue(
            event[type][key],
            options
          );
        }
        break;
      case "string":
        // console.log("string", type);
        attributes[type] = await generateDataLayerValue(event[type], options);
        // console.log("attributes[type]", attributes[type]);

        break;
      default:
        break;
    }
  }
  // console.log("attributes", attributes);
  return attributes;
};

const events = [
  "view_item_list",
  "select_item",
  "view_item",
  "add_to_cart",
  "remove_from_cart",
  "begin_checkout",
  "add_shipping_info",
  "add_payment_info",
  "purchase",
  "view_promotion",
];

const getEcommerceEvent = (eventtype) => {

  return events.includes(eventtype);
};

const generateAnalytics = async (eventtype, options, module) => {
  const date = new Date().getTime();
  window.dataLayer = window.dataLayer || [];

  // window.dataLayer.splice(0, window.dataLayer.length);

  // console.log(" window.dataLayer", window.dataLayer);


  if (eventtype === "pageLoad") {

    const attributes = await generateDataLayer(eventtype, options);


    const pageLoadoptions = {
      event: "orm_pageLoad",
      module,
      timestamp: date,
      type: eventtype,
      attributes,
      options,
    }

    if (get_ga_sessid()) pageLoadoptions.session_id = get_ga_sessid();
    if (get_ga_clientid()) pageLoadoptions.client_id = get_ga_clientid();
    if (addGclid()) pageLoadoptions.gclid = addGclid();

    window.dataLayer.push(pageLoadoptions);
    return false;
  }

  if (getEcommerceEvent(eventtype)) {

    const ecommerce = await generateDataLayer(eventtype, options);


    const ecomoptions = {
      event: eventtype,
      ecommerce,
    }


    if (get_ga_sessid()) ecomoptions.session_id = get_ga_sessid();
    if (get_ga_clientid()) ecomoptions.client_id = get_ga_clientid();
    if (addGclid()) ecomoptions.gclid = addGclid();


    window.dataLayer.push(ecomoptions);


    return false;
  }

  const attributes = await generateDataLayer(eventtype, options);

  const standardoptions = {
    event: eventtype, // Formaly orm_click
    module,
    timestamp: date,
    type: eventtype,
    attributes,
  }

  if (get_ga_sessid()) standardoptions.session_id = get_ga_sessid();
  if (get_ga_clientid()) standardoptions.client_id = get_ga_clientid();
  if (addGclid()) standardoptions.gclid = addGclid();
  window.dataLayer.push(standardoptions);


};

const generateAdobe = async (eventtype, options, moduleName) => {
  // console.log("adobe", eventtype, options, moduleName);
  const config = JSON.parse(process.env.VUE_APP_ANALYTICS_CONFIG);
  // console.log(config);
  if (eventtype === "pageLoad") {
    eventtype = eventtype + "_" + options.pageType;
  }

  if (moduleName) {
    eventtype = eventtype + "_" + moduleName;
  }

  if (eventtype === "headerStep_jump" + "_" + moduleName) {
    eventtype = eventtype + "_" + options.to;
  }

  if (eventtype === "reservation_change" + "_" + moduleName) {
    eventtype = eventtype + "_" + options.to;
  }

  window.dataLayer = [];
  const event = config.orm[eventtype];
  // console.log(eventtype);
  // console.log(event);
  for (const key in event) {
    if (key !== "_satellite") {
      window.dataLayer[key] = await generateDataLayerValue(event[key], options);
    }
  }
  if (window._satellite) {
    window._satellite.track(event["_satellite"]);
  }

  // console.log(window.dataLayer);
};

const buildDataLayer = async (eventtype, options, moduleName) => {
  // console.log(process.env.VUE_APP_ANALYTICS_CONFIG);
  if (process.env.VUE_APP_ANALYTICS_DATALAYER === "true") {
    if (process.env.VUE_APP_ANALYTICS_ADOBE === "true") {
      await generateAdobe(eventtype, options, moduleName);
    } else {
      await generateAnalytics(eventtype, options, moduleName);
    }
  } else {
    return false;
  }
};


export {buildDataLayer, get_ga_clientid, get_ga_sessid, addGclid};
